import axios from "axios";
import { removeAccessToken } from "./slices/authSlice";
import { removeToken } from "../Data/services/localStorageService";
import { baseRoute } from "../Helper";
import { WEB_ROUTES } from "../constants";

let loggingOut = false;

/**
 * Clears session and sends user to login. Guarded so axios + Redux middleware
 * don’t run the flow twice for one 401.
 */
export function forceLogoutOn401(store) {
  if (loggingOut) return;
  loggingOut = true;

  try {
    removeToken();
    store.dispatch(removeAccessToken());
  } catch (e) {
    console.error(e);
  }

  const path = baseRoute(WEB_ROUTES.ACCOUNT);
  const onAccountPage = window.location.pathname.includes(`/${WEB_ROUTES.ACCOUNT}`);

  if (!onAccountPage) {
    window.location.assign(path);
  } else {
    loggingOut = false;
  }
}

function isLoginRequest(url) {
  if (!url) return false;
  const u = String(url).toLowerCase();
  return u.includes("/login");
}

/**
 * Har axios response par: HTTP 401 → logout (login call chhod kar).
 */
export function attachAxios401Interceptor(store) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const url = error.config?.url || "";

      if (status === 401 && !isLoginRequest(url)) {
        forceLogoutOn401(store);
      }

      return Promise.reject(error);
    }
  );
}
